/*************************** MENSAJESDE REGISTRO ***********************/
export const MSJ_EXITO_TIULO = 'GRACIAS';
export const MSJ_EXITO_SUBTIULO = '¡TUS DATOS HAN SIDO REGISTRADOS!';
export const MSJ_EXITO_CUERPO = 'Tu registro se ha completado con éxito. Gracias por participar en el sorteo';

/*************************** MENSAJESDE REGISTRO ***********************/
export const MSJ_ERROR_TIULO = '¡ERROR!';
export const MSJ_ERROR_SUBTIULO = '¡OCURRIO UN ERROR AL REGISTRARSE!';
export const MSJ_ERROR_CUERPO = 'No se pudo completar la accion, por favor intentelo nuevamente';